import { render, staticRenderFns } from "./ResponsibilityBadgeHoldersTab.vue?vue&type=template&id=bc40f096"
import script from "./ResponsibilityBadgeHoldersTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsibilityBadgeHoldersTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports